import type { FC, PropsWithChildren } from "react";
import { useTranslations } from "next-intl";

import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { cn } from "@/ui/lib/utils";
import { Field } from "../Field";
import { InputError } from "../InputError";
import { Label } from "../Label";

type TFieldWrapperProps = PropsWithChildren<{
  className?: string;
  componentName: string;
  disabled?: boolean;
  error?: string;
  label: string;
  required?: boolean;
}>;

export const FieldWrapper: FC<TFieldWrapperProps> = (
  {
    children,
    className,
    componentName,
    disabled,
    error,
    label,
    required,
  },
) => {
  const t = useTranslations("Shared.Forms");

  return (
    <Field
      data-component={componentName}
      className={cn(
        "cursor-pointer grid gap-x-2 w-full",
        disabled && "cursor-not-allowed",
        className,
      )}
    >
      <Grid gap="3">
        <Column>
          <Label className={cn("peer-disabled:opacity-70")}>
            { label } { required === false ? `(${t("optional")})` : null }
          </Label>
        </Column>
        <Column>
          { children }
        </Column>
        { error ? (
          <Column>
            <InputError>{ error }</InputError>
          </Column>
        ) : null }
      </Grid>
    </Field>
  );
};
